/**
 * 모델
 * @window w_tb_ca642w_15
 * @category 월별 손익계산서 지급 팝업창
 */
export class PaymentModalModel {
  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  custcd: string;

  /**
   * 사업장코드
   *
   * **data type** varchar(8)
   */
  spjangcd: string;

  /**
   * 계정코드
   *
   * **data type** varchar(8)
   */
  artcd: string;

  /**
   * 계정명
   *
   * **data type** varchar(8)
   */
  artnm: string;

  /**
   * 거래처코드
   *
   * **data type** varchar(8)
   */
  cltcd: string;

  /**
   * 거래처명
   *
   * **data type** varchar(8)
   */
  cltnm: string;

  /**
   * 부서코드
   *
   * **data type** varchar(8)
   */
  divicd: string;

  /**
   * 부서명
   *
   * **data type** varchar(8)
   */
  divinm: string;

  /**
   * 구분
   *
   * **data type** varchar(8)
   */
  gubun: string;

  /**
   * 그룹계정 코드
   *
   * **data type** varchar(8)
   */
  gartcd: string;

  /**
   * 그룹계정명
   *
   * **data type** varchar(8)
   */
  gartnm: string;

  /**
   * 지급금액
   *
   * **data type** varchar(8)
   */
  sndamt: string;

  /**
   * 모름
   *
   * **data type** varchar(8)
   */
  sndcltcd: string;

  /**
   * 모름
   *
   * **data type** varchar(8)
   */
  sndcltnm: string;

  /**
   * 지급일자
   *
   * **data type** varchar(8)
   */
  snddate: string;

  /**
   * 지급번호
   *
   * **data type** varchar(8)
   */
  sndnum: string;

  /**
   *  프로젝트명
   *
   * **data type** varchar(8)
   */
  projnm: string;

  /**
   * 프로젝트번호
   *
   * **data type** varchar(8)
   */
  projno: string;

  /**
   * 모름
   *
   * **data type** varchar(8)
   */
  proof: string;

  /**
   * 적요
   *
   * **data type** varchar(8)
   */
  remark: string;

  /**
   * 모름
   *
   * **data type** varchar(8)
   */
  taxreclafi: string;

  /**
   * 모름
   *
   * **data type** varchar(8)
   */
  wkgubun: string;

  constructor(data: any = {}) {
    this.custcd = data.custcd || '';
    this.spjangcd = data.spjangcd || '';
    this.artcd = data.artcd || '';
    this.artnm = data.artnm || '';
    this.cltcd = data.cltcd || '';
    this.cltnm = data.cltnm || '';
    this.gartcd = data.gartcd || '';
    this.gartnm = data.gartnm || '';
    this.divicd = data.divicd || '';
    this.divinm = data.divinm || '';
    this.gubun = data.gubun || '';
    this.sndamt = data.sndamt || '';
    this.sndcltcd = data.sndcltcd || '';
    this.sndcltnm = data.sndcltnm || '';
    this.snddate = data.snddate || '';
    this.sndnum = data.sndnum || '';
    this.projnm = data.projnm || '';
    this.projno = data.projno || '';
    this.proof = data.proof || '';
    this.remark = data.remark || '';
    this.taxreclafi = data.taxreclafi || '';
    this.wkgubun = data.wkgubun || '';
  }
}
